import fetchJson from '../services/http.service';

let hasSession = false;
let onUnauthorized = null;

export async function loginWithFaseCredentials(username, password) {
  const result = await fetchJson('/api/faseAuth/login', 'POST', { username, password });
  hasSession = true;
  return result;
}

export function clearCredentials() {
  hasSession = false;
}

export async function logoutFaseSession() {
  clearCredentials();
  await fetchJson('/api/faseAuth/logout', 'POST');
}

export function hasStoredCredentials() {
  return hasSession;
}

export async function refreshFaseSessionStatus() {
  try {
    const status = await fetchJson('/api/faseAuth/session');
    hasSession = Boolean(status && status.authenticated);
  } catch {
    hasSession = false;
  }
  return hasSession;
}

export function setOnUnauthorized(callback) {
  onUnauthorized = callback;
}

export function isUnauthorizedError(error) {
  return error === 'Unauthorized' || (error && error.message === 'Unauthorized');
}

export async function fetchWithFaseAuth(url) {
  try {
    return await fetchJson(url, undefined, undefined, {});
  } catch (error) {
    if (isUnauthorizedError(error)) {
      clearCredentials();
      if (onUnauthorized) {
        onUnauthorized();
      }
    }
    throw error;
  }
}
